
export function getRoleId(userRoles, currentRole) {
  return userRoles.find(elem => elem.role === currentRole).id;
}
